<template>
	<div class="popup" v-show="subfileShow" v-cloak>
		<div class="content" id="subfile">
			<div class="title">
				<span>{{$t('language.popup.remoteTaskPopup.createBtTask')}}</span>
				<div class="icon white-close dialog-close" @click="destory()"></div>
			</div>
			<div class="subfile-introduction">
				<div class="subfile-introduction-saving" :title="wholeName">{{name}}<span ref="nameSuffx" style="display:none;">...</span></div>
				<div class="subfile-introduction-size subfie-font-size">{{$t('language.common.size')}}:{{totalSize}}</div>
			</div>
			<div style="height: 300px;">
				<el-scrollbar style="height:100%">
				<el-table ref="subfileDataTable" :data="tableData" @selection-change="isSelected" style="width: 100%;font-size: 13px;">
					<el-table-column type="selection" align="left" width="30"></el-table-column>
					<el-table-column prop="name" width="225" class="subfile-pointer">
						<template slot="header" slot-scope="scope">
							<div @click="sortName()">
								<span class="subfile-pointer">{{selectedName}}</span>
								<span v-if="arrowShow == 'name'">
									<i v-if="!nameSort" class="icon-util down-arrow"></i>
									<i v-if="nameSort" class="icon-util up-arrow"></i>
								</span>
							</div>
						</template>
						<template slot-scope="scope">
							<div class="small-file tr-file-position" :class="matchfileType(scope.row.name)+'-small'"></div>
							<span v-html='scope.row.nameTxt'></span>
						</template>
					</el-table-column>
					<el-table-column prop="type" width="100">
						<template slot="header" slot-scope="scope">
							<div @click="sortType()">
								<span class="subfile-pointer">{{$t('language.common.type')}}</span>
								<span v-if="arrowShow == 'type'">
									<i v-if="!typeSort" class="icon-util down-arrow"></i>
									<i v-if="typeSort" class="icon-util up-arrow"></i>
								</span>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="sizeTxt" width="100">
						<template slot="header" slot-scope="scope">
							<div @click="sortSize()">
								<span class="subfile-pointer">{{$t('language.common.size')}}</span>
								<span v-if="arrowShow == 'size'">
									<i v-if="!sizeSort" class="icon-util down-arrow"></i>
									<i v-if="sizeSort" class="icon-util up-arrow"></i>
								</span>
							</div>
						</template>
					</el-table-column>
				</el-table>
				</el-scrollbar>
			</div>
			<div class="subfile-foot">
				<button v-loading='loading' class="foot-download" @click="download()">{{$t('language.common.download')}}</button>
				<button class="foot-cancel" @click="destory()">{{$t('language.common.cancel')}}</button>
			</div>
			<transition>
				<div class="flow-sync-icon" v-if="flowShow" id='offlineFlow'>
					<div class="icon transfer-task-position cloudsync flow-sync-position"></div>
				</div>
			</transition>
		</div>
	</div>
</template>

<script>
	import commonUtils from "@/js/workspace/common_util.js";
	import taskListUtils from "@/js/workspace/task_list_util.js";
	import taskOfflineUtils from '@/js/workspace/task_offline_util.js';
	export default {
		data: function() {
			return {
				flowShow: false,
				subfileShow: false,
				arrowShow: null,
				sizeSort: true,
				typeSort: false,
				nameSort: false,
				name: '',
				wholeName: '',
				selectedList: [],
				selectedName: "",
				loading: false,
				cloudSite: null,
				sourceId: null,
				type: null,
				totalSize: "0",
				tableData: []
			};
		},
		methods: {
			initData(data) {
				this.totalSize = 0;
				if (data) {
					this.tableData = data.array;
					this.wholeName = data.name;
					this.name = this.getShorthand(data.name, 40);
					if (this.name.length < this.wholeName.length) {
						this.$refs.nameSuffx.style.display = null;
					}
					this.type = data.type;
					this.sourceId = data.id;
					for (var i = 0; i < this.tableData.length; i++) {
						const item = this.tableData[i];
						const size = item.size;
						item.sizeTxt = commonUtils.sizeUtil(size);
						item.nameTxt = this.getShorthand(item.name, 20);
						this.totalSize = parseInt(this.totalSize) + parseInt(size);
					}
					this.bubbleSort(this.tableData, false)
					this.$refs.subfileDataTable.toggleAllSelection()
					this.totalSize = commonUtils.sizeUtil(this.totalSize)
				}
			},
			getShorthand(str, limit) {
				let count = this.moreThanCount(str);
				var realLen = str.length + count;
				if (realLen > limit) {
					let sub = str.substr(0, limit);
					let subCount = this.moreThanCount(sub);
					return str.substr(0, limit - subCount) + "...";
				}
				return str;
			},
			moreThanCount(str) {
				var count = 0;
				for (var i = 0; i < str.length; i++) {
					const success = str[i].replace(/[\u0391-\uFFE5]/g, "aa");
					if (success == "aa") {
						count++;
					}
					let isUpper = str[i].toLowerCase().charCodeAt() - 32 == str[i].charCodeAt();
					if (isUpper) {
						count = count + 0.5;
					}
				}
				return parseInt(count);
			},
			isSelected(rows) {
				this.selectedName = rows.length + this.$t('language.popup.remoteTaskPopup.torrentSelected');
				var size = 0;
				rows.forEach(row => {
					size += parseInt(row.size);
				});
				this.totalSize = commonUtils.sizeUtil(size);
				this.selectedList = rows;
			},
			destory() {
				this.subfileShow = false;
				this.selectedList = [];
				this.total = "";
				this.totalSize = "0";
				this.tableData = [];
				this.offlineFlow = false;
				this.loading = false;
				this.flowShow = false;
			},
			sortSize() {
				this.arrowShow = "size";
				this.sizeSort = !this.sizeSort;
				if (this.tableData) {
					this.bubbleSort(this.tableData, this.sizeSort);
					this.selectedList.forEach(item => {
						this.$nextTick(() => {
							this.$refs.subfileDataTable.toggleRowSelection(item, true);
						})
					})
				}
			},
			sortName() {
				this.arrowShow = "name";
				this.nameSort = !this.nameSort;
				if (this.tableData) {
					this.nnameSort(this.tableData, this.nameSort);
					this.selectedList.forEach(item => {
						this.$nextTick(() => {
							this.$refs.subfileDataTable.toggleRowSelection(item, true);
						})
					})
				}
			},
			sortType() {
				this.arrowShow = "type";
				this.typeSort = !this.typeSort;
				if (this.tableData) {
					this.ttypeSort(this.tableData, this.typeSort);
					this.selectedList.forEach(item => {
						this.$nextTick(() => {
							this.$refs.subfileDataTable.toggleRowSelection(item, true);
						})
					})
				}
			},
			download() {
				// 防止多次点击
				if (this.loading) {
					return;
				}
				let that = this;
				var fileNameList = [];
				var selectedSize = 0;
				this.selectedList.forEach(file => {
					fileNameList.push(file.name);
					selectedSize += parseFloat(file.size);
				});
				// 所选文件总量不能大于50G
				// if(selectedSize > 50 * 1024 * 1024 * 1024){
				// 	this.$toast({
				// 		text: that.$t('language.remoteTask.selectedFileLimit'),
				// 		type: 'fail',
				// 		idValue: "subfile"
				// 	});
				// 	return;
				// }
				// 所选文件总个数不能超过500
				// if(fileNameList.length > 500){
				// 	this.$toast({
				// 		text: that.$t('language.remoteTask.selectedFileLimit'),
				// 		type: 'fail',
				// 		idValue: "subfile"
				// 	});
				// 	return;
				// }
				// 名称检查
				if (!this.verify(fileNameList)) {
					return;
				}
				this.loading = true;
				var requestData = new taskOfflineUtils.addTorrentTask(JSON.parse(localStorage.getItem("user")).id,
					this.sourceId, this.type, fileNameList, this.cloudSite, selectedSize);

				this.Utils.doTorrentRequest('add', requestData).then(res => {
					if (res.status == 200) {
						var data = res.data;
						const task = {
							"filesize": selectedSize,
							"result": data.state,
							"name": data.name,
							"percent": "0.00",
							"id": data.id,
							"toItem": data.toItem,
							"type": data.type,
							"url": data.url
						};
						task.toItem.id = data.toItem.fileId;
						task.toItem.name = data.toItem.filename;
						if (this.$parent.offlineTaskData) {
							this.$parent.offlineTaskData.unshift(task);
							this.destory();
						} else {
							// 如果当前页面不是离线任务列表页面，执行动画效果。
							let that = this;
							this.initStoreCache(task, function(){
								that.exeCuteFlowIcon();
							});
						}
					} else {
						let text;
						if (res.reason == 'addTaskFail') {
							text = this.$t('language.exception.addTaskFail');
						}
						if (res.reason == 'TOMPF') {
							text = this.$t('language.remoteTask.taskExpired');
						}
						if (res.reason == 'saltInvalid') {
							text = this.$t('language.exception.saltInvalid');
						}
						if (res.reason == 'torrentTort') {
							text = this.$t('language.exception.torrentTort');
						}
						if( res.reason == 'trafficNotEnough'){
							text = this.$t('language.popup.upgradeAccountPopup.insufficientTrafficDes');
						}
						if (res.reason == 'taskMaximumNumberLimited'){
							text = this.$t('language.exception.exceedMaxLimit');
						}
						this.loading = false;
						this.$toast({
							text: text == null ? that.$t('language.exception.' + res.reason):text,
							type: 'fail',
							idValue: "subfile"
						});
					}
				}, err => {
					this.loading = false;
					that.$toast({
						text: err,
						type: 'fail',
						idValue: "allBox"
					});
				});
			},
			initStoreCache(itemData, callback) {
				let that = this;
				let offlineList = this.$store.state.remoteTaskArr;
				if (!offlineList) {
					this.initOfflineData(function(offlineData) {
						offlineList = offlineData;
						// offlineList.unshift(itemData);
						that.$store.commit("setRemoteTaskArr", offlineList);
						callback();
					})
				} else {
					offlineList.unshift(itemData);
					this.$store.commit("setRemoteTaskArr", offlineList);
					callback();
				}
			},
			initOfflineData(callback) {
				var that = this;
				var list = [];
				var offLineData = new taskListUtils.taskListData(JSON.parse(localStorage.getItem("user")).id, 3);
				this.Utils.doTasksRequest("list", offLineData).then(res => {
					if (res.status == 200) {
						var offlineTasks = res.tasks;
						offlineTasks.sort(function(a, b) {
						  return -(a.createTime - b.createTime)
						});
						callback(offlineTasks);
					} else {
						this.loading = false;
						that.$toast({
							text: res.reason,
							type: 'fail',
							idValue: "allBox"
						});
					}
				}, err => {
					that.$toast({
						text: err,
						type: 'fail',
						idValue: "allBox"
					});
				});
			},
			verify(fileNameList) {
				if (!this.type || !this.cloudSite) {
					this.$toast({
						text: this.$t('language.remoteTask.unKnownError'),
						type: 'fail',
						idValue: "subfile"
					});
					return false;
				}
				if (fileNameList.length == 0) {
					this.$toast({
						text: this.$t('language.popup.cloudTransferPopup.pleaSelect'),
						type: 'fail',
						idValue: "subfile"
					});
					return false;
				}
				return true;
			},
			ttypeSort(data, downSort) {
				let that = this;
				// 忽略大小写
				data.sort(function(o, p) {
					if (downSort) {
						return that.strCompare(o.type, p.type)
					} else {
						return that.strCompare(p.type, o.type)
					}
				});
			},
			nnameSort(data, downSort) {
				let that = this;
				// 忽略大小写
				data.sort(function(o, p) {
					if (downSort) {
						return that.strCompare(o.name, p.name)
					} else {
						return that.strCompare(p.name, o.name)
					}
				});
			},
			bubbleSort(data, downSort) {
				data.sort(function(x, y) {
					if (downSort) {
						return x.size - y.size;
					} else {
						return y.size - x.size;
					}
				});
			},
			strCompare(str1, str2) {
				if (str1 != null && str2 != null) {
					let str1Array = str1.split('');
					let str2Array = str2.split('');
					let min = str1Array.length > str2Array.length ? str2Array.length : str1Array.length;
					let k = 0;
					while (k < min) {
						let a = str1Array[k].toUpperCase();
						let b = str2Array[k].toUpperCase();
						if (a != b) {
							return a.charCodeAt() - b.charCodeAt();
						}
						k++;
					}
					return str1Array.length - str2Array.length;
				}
			},
			matchfileType(fileName) {
				return commonUtils.matchfileTypes(fileName);
			},
			exeCuteFlowIcon() {
				let that = this;
				let dom;
				let taskRedMark = document.getElementById("listRedMark5");
				that.flowShow = true;
				this.$nextTick(function() {
					that.flowTransferIcon();
				});
				var mc_project = that.$parent.$parent;
				$.each(mc_project.$children, function(i, item) {
					if (item.menuOptions) { //如果是left_banner组件
						dom = mc_project.$children[i];
						return;
					}
				});
				dom.taskListNumber = dom.taskListNumber + 1;
				setTimeout(() => {
					taskRedMark.style.display = 'block';
					that.destory();
				}, 1300);
			},
			flowTransferIcon() {
				let flowIcon = document.getElementById("offlineFlow");
				let taskListIcon = document.getElementById("menuOption5");
				//获取传输图标应该移动的距离并设置样式
				let xPx = taskListIcon.getBoundingClientRect().left - flowIcon.getBoundingClientRect().left;
				let yPx = taskListIcon.getBoundingClientRect().bottom - flowIcon.getBoundingClientRect().bottom;
				flowIcon.style.transition = 'all 1.4s ease';
				flowIcon.style.transform = 'translate3d(' + xPx + 'px, ' + yPx + 'px, 0px) scale(1.2) scale(1)';
				setTimeout(() => {
					flowIcon.style.transition = 'none';
					flowIcon.style.transform = 'translateX(1px)';
					flowIcon.style.opacit = '0';
				}, 1500);
			},
		},
	};
</script>

<style>
	#subfile {
		width: 500px;
		/*no*/
		height: 500px;
		/*no*/
		border: none;
	}

	#banner {
		background-color: lightgray;
		color: black;
		font-weight: 700;
	}


	#uploadLoading {
		margin-top: 2px;
		/*no*/
	}

	#subfile .cell {
		padding-left: 0px !important;
		/*no*/
	}

	#subfile .el-loading-spinner .path {
		stroke: #FFFFFF !important;
	}
  #subfile .el-scrollbar__thumb{
    min-height: 10%;
   }

	#subfile .el-table th>.cell {
		padding-right: 0 !important;
	}

	#subfile .el-loading-spinner .circular {
		height: 0.25rem !important;
		width: 0.25rem !important;
	}

	#subfile .el-loading-spinner {
		line-height: 0.95rem !important;
	}

	.subfile-pointer {
		cursor: pointer;
	}

	#subfile .el-loading-mask {
		background-color: rgba(81, 102, 189, 2) !important;
		z-index: 10 !important;

	}

	#subfile .el-table__header tr,
	#subfile .el-table__header th {
		padding: 0 !important;
		height: 10px !important;
		/*no*/
		border-bottom: none;
	}

	#subfile .el-checkbox:last-of-type {
		margin-right: 15px !important;
		/*no*/
	}

	#subfile .el-table__body tr,
	#subfile .el-table__body td {
		padding: 0 !important;

	}

	#subfile .el-table::before{
		height: 0;
	}

	#subfile .el-checkbox__input {
		margin-bottom: 5px;/*no*/
	}

	#subfile .el-checkbox__inner {
		width: 15px !important;
		/*no*/
		height: 14px !important;
		/*no*/
		border: 1px solid #DCDFE6 !important;
		/*no*/
		border-radius: 0px;
		/*no*/
		margin-bottom: 3px;
		/*no*/
	}

	#subfile .el-table td,
	.el-table th {
		min-width: 0 !important;
		-webkit-box-sizing: border-box !important;
		box-sizing: border-box !important;
		text-overflow: ellipsis !important;
		vertical-align: middle !important;
		position: relative !important;
		text-align: left !important;
	}
	#subfile .el-table td, .el-table th.is-leaf{
		border-bottom: 1px solid #eef1f6;/*no*/
	}

	#subfile .el-checkbox__input.is-checked .el-checkbox__inner,
	#subfile .el-checkbox__input.is-indeterminate .el-checkbox__inner {
		background-color: #4282ff !important;
	}
	#subfile .el-table thead{
		color: #afb1b6;
	}
	#subfile .el-table{
		color: #6e7178;
	}

	#subfile .el-table__body, .el-table__footer, .el-table__header{
		padding-left: 20px;/*no*/
	}

	#subfile .el-table-column--selection .cell {
		padding-left: 0rem !important;
		padding-right: 0 !important;
		margin: 0 auto !important;
	}

	#subfile .el-checkbox__input.is-indeterminate .el-checkbox__inner::before{
		top: 5px;/*no*/
	}

	#subfile .el-checkbox__inner::after {
		-webkit-box-sizing: content-box !important;
		box-sizing: content-box !important;
		content: "" !important;
		border: 1.5px solid white !important;
		/*no*/
		border-left: 0 !important;
		border-top: 0 !important;
		height: 7.5px !important;
		/*no*/
		left: 2px !important;
		/*no*/
		margin-left: 1.5px;
		/*no*/
		position: absolute !important;
		top: 0 !important;
		width: 3px !important;
		/*no*/
		transition: transform .15s ease-in .05s, -webkit-transform .15s ease-in .05s !important;
		transform-origin: center !important;
	}

	.subfile-introduction {
		height: 50px;
		/*no*/
		margin-left: 20px;
		/*no*/
	}

	.subfile-introduction-saving {
		margin-top: 18px;
		/*no*/
		font-weight: bold;

	}

	.subfile-introduction-saving:hover {
		cursor: pointer;
	}

	.subfile-introduction-size {
		margin-top: 6px;
		/*no*/
		margin-bottom: 18px;
		/*no*/
		font-weight: 300;
		color: dimgrey;
	}

	.subfie-font-size {
		font-size: 13px;
		/*no*/
	}

	.subfie-pointer {
		cursor: pointer;
	}

	.subfile-foot {
		position: absolute;
		right: 20px;
		/*no*/
		bottom: 10px;
		/*no*/
	}

	.foot-download {
		margin-right: 10px;
		/*no*/
	}

	.foot-cancel {
		background-color: white;
		border: 0.5px solid #5166BD;
		/*no*/
		color: #5166BD;
	}

	.foot-cancel:hover {
		color: white;
		border: 0.5px solid #3250c9;
		/*no*/
	}


	#subfile .el-table--scrollable-y .el-table__body-wrapper{
		overflow: hidden;
	}
</style>



// WEBPACK FOOTER //
// src/components/popup/remote_task_popups/subfile_select_popup.vue